import React from 'react';
import SvgIcon from './SvgIcon';

const Condensed = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M3 6a1 1 0 100-2 1 1 0 000 2zM3 13a1 1 0 100-2 1 1 0 000 2zM3 20a1 1 0 100-2 1 1 0 000 2z"
                fill="currentColor"
            />
            <rect x={6} y={4} width={15} height={2} rx={1} fill="currentColor" />
            <rect x={6} y={11} width={15} height={2} rx={1} fill="currentColor" />
            <rect x={6} y={18} width={15} height={2} rx={1} fill="currentColor" />
        </SvgIcon>
    );
};

Condensed.displayName = 'CondensedIcon';

export default Condensed;
